// Class: starling.assets.AssetType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function Std() {return require("./../../Std");}
function starling_textures_Texture() {return require("./../../starling/textures/Texture");}
function starling_textures_TextureAtlas() {return require("./../../starling/textures/TextureAtlas");}
function openfl_media_Sound() {return $import(require("openfl/media/Sound"));}
function Xml() {return require("./../../Xml");}
function openfl_utils_ByteArray() {return $import(require("openfl/utils/ByteArray"));}
function starling_text_BitmapFont() {return require("./../../starling/text/BitmapFont");}
function starling_assets_AssetManager() {return require("./../../starling/assets/AssetManager");}

// Constructor

var AssetType = function(){}

// Meta

AssetType.__name__ = ["starling","assets","AssetType"];
AssetType.prototype = {
	
};
AssetType.prototype.__class__ = AssetType.prototype.constructor = $hxClasses["starling.assets.AssetType"] = AssetType;

// Init



// Statics

AssetType.fromAsset = function(asset) {
	if((Std().default)["is"](asset,(starling_textures_Texture().default))) {
		return AssetType.TEXTURE;
	} else if((Std().default)["is"](asset,(starling_textures_TextureAtlas().default))) {
		return AssetType.TEXTURE_ATLAS;
	} else if((Std().default)["is"](asset,(openfl_media_Sound().default))) {
		return AssetType.SOUND;
	} else if((Std().default)["is"](asset,(Xml().default))) {
		return AssetType.XML_DOCUMENT;
	} else if((Std().default)["is"](asset,(openfl_utils_ByteArray().default))) {
		return AssetType.BYTE_ARRAY;
	} else if((Std().default)["is"](asset,(starling_text_BitmapFont().default))) {
		return AssetType.BITMAP_FONT;
	} else if((Std().default)["is"](asset,(starling_assets_AssetManager().default))) {
		return AssetType.ASSET_MANAGER;
	} else {
		return AssetType.OBJECT;
	}
}
AssetType.TEXTURE = "texture"
AssetType.TEXTURE_ATLAS = "textureAtlas"
AssetType.SOUND = "sound"
AssetType.XML_DOCUMENT = "xml"
AssetType.OBJECT = "object"
AssetType.BYTE_ARRAY = "byteArray"
AssetType.BITMAP_FONT = "bitmapFont"
AssetType.ASSET_MANAGER = "assetManager"

// Export

exports.default = AssetType;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/assets/AssetType.js
// module id = 138
// module chunks = 0